<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>The incapacity of Harun to restrain the followers of the Calf . . . was a wisdom from God made manifest in existence: that He be worshipped in every form.</p>
<p class="ept">Muhyi al-Din Ibn ʿArabi</p>
<p class="epf">Democracy has no monuments. . . . Its very essence is iconoclastic.</p>
<p class="ept">John Quincy Adams</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-tugendhaft-0006.vue?57f90959